import { Col, Row, Form, Input, Button } from "antd";
import { useSelector } from "react-redux";
import { RESET } from "../../config/constants/api";
import swal from "sweetalert";
import { useNavigate } from "react-router-dom";
import { Post } from "../../config/api/post";
import { FaArrowLeftLong } from "react-icons/fa6";

const EditProfile = () => {
  const [form] = Form.useForm();
  const token = useSelector((state) => state.user.userToken);
  const userData = useSelector((state) => state.user.userData);
  const navigate = useNavigate();
  const onFinish = (values) => {
    if (values?.password !== values?.confirmpassword) {
      swal("Error", "Password and Confirm Password should match", "error");
      return;
    }
    let body = {
      email: userData.email,
      type: "USER",
      password: values?.password,
      oldPassword: values.oldPassword,
    };
    Post(RESET.changePassword, body, token)
      .then((response) => {
        if (response.status) {
          form.resetFields();
          showAlert();
          navigate("/Profile");
        }
      })
      .catch((err) => {
        console.log("Error", err);
        swal("Error", err?.response?.data?.message, "error");
      });
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };
  const showAlert = () => {
    swal("system Alert", "Your password has been updated", "success");
  };

  return (
    <Row justify="center" className="py-16 max-sm:py-8 bg-white">
      <Col md={8} sm={22} xs={22}>
        <FaArrowLeftLong
          className="arrow cursor-pointer"
          onClick={() => navigate(-1)}
        />
        <Row justify="center">
          <h3 className="font-tavi text-3xl text-black max-sm:text-xl font-semibold">
            Change Password
          </h3>
        </Row>

        <Form
          layout="vertical"
          name="basic"
          initialValues={{
            remember: true,
          }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
          form={form}
        >
          <Form.Item
            label={
              <p className="font-euclid text-sm text-[#34324B] font-bold">
                Old Password
              </p>
            }
            name="oldPassword"
            rules={[
              {
                required: true,
                message: "Please input your Old Password!",
              },
              {
                type: "string",
              },
            ]}
          >
            <Input.Password
              size="large"
              placeholder="Enter Old Password"
              className="h-12 text-sm font-euclid bg-gray-100 max-sm:text-xs"
            />
          </Form.Item>
          <Form.Item
            label={
              <p className="font-euclid text-sm text-[#34324B] font-bold">
                New Password
              </p>
            }
            name="password"
            rules={[
              {
                required: true,
                message: "Please input your New Password!",
              },
              {
                type: "string",
              },
            ]}
          >
            <Input.Password
              size="large"
              placeholder="Enter New Password"
              className="h-12 text-sm font-euclid bg-gray-100 max-sm:text-xs"
            />
          </Form.Item>
          <Form.Item
            label={
              <p className="font-euclid text-sm text-[#34324B] font-bold">
                Confirm Password
              </p>
            }
            name="confirmpassword"
            rules={[
              {
                required: true,
                message: "Please input your Confirm Password!",
              },
              {
                type: "string",
              },
            ]}
          >
            <Input.Password
              size="large"
              placeholder="Confirm Password"
              className="h-12 text-sm font-euclid bg-gray-100 max-sm:text-xs"
            />
          </Form.Item>
          <Form.Item style={{ textAlign: "center" }}>
            <Button
              type="button"
              htmlType="submit"
              className="web-btn xl:px-12 px-3 text-sm max-xl:text-xs mx-4"
              style={{
                cursor: "pointer",
                margin: "2px",
              }}
            >
              
              Save
            </Button>
            <Button
              type="button"
              htmlType="submit"
              className="web-btn  xl:px-12 px-3 text-sm max-xl:text-xs mx-4"
              style={{
                cursor: "pointer",
                margin: "2px",
                background: "#000",
                color: "#fff",
              }}
              onClick={() => navigate("/profile")}
            >
              Cancel
            </Button>
          </Form.Item>
        </Form>
      </Col>
    </Row>
  );
};

export default EditProfile;
